/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  //FOLLOWUP
  LOAD_FOLLOWUP,
  LOAD_FOLLOWUP_SUCCESS,
  LOAD_FOLLOWUP_ERROR,

  UPDATE_FOLLOWUP,
  UPDATE_FOLLOWUP_SUCCESS,
  UPDATE_FOLLOWUP_ERROR
  
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Followup
export function loadFollowup(searchvalue) {
  return {
    type: LOAD_FOLLOWUP,
    searchvalue,
  }
}
export function loadFollowupSuccess(followup_details) {
  return {
    type: LOAD_FOLLOWUP_SUCCESS,
    followup_details,
  }
}
export function loadFollowupError(error) {
  return {
    type: LOAD_FOLLOWUP_ERROR,
    error,
  }
}
//updateFollowup
export function updateFollowup(update_details) {
  return {
    type: UPDATE_FOLLOWUP,
    update_details,
  }
}
export function updateFollowupSuccess(followup_details) {
  return {
    type: UPDATE_FOLLOWUP_SUCCESS,
    followup_details,
  }
}
export function updateFollowupError(error) {
  return {
    type: UPDATE_FOLLOWUP_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadFollowup,
  loadFollowupSuccess,
  loadFollowupError,

}

export default actions
